import React from 'react';
import { IonButton, IonIcon, IonText, IonCard, IonCardContent } from '@ionic/react';
import { closeCircle, arrowBack } from 'ionicons/icons';
import { useLocation } from 'react-router-dom';
import PaymentPageLayout from './PaymentPageLayout';
import styles from './PaymentPages.module.css';

const PaymentCancelPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const deviceId = queryParams.get('deviceId');

  return (
    <PaymentPageLayout title="Payment Cancelled">
      <div className={styles.paymentPageContainer}>
        <IonIcon
          icon={closeCircle}
          className={styles.icon}
          color="warning"
        />

        <IonText color="dark">
          <h1 className={styles.title}>Payment Cancelled</h1>
          <p className={styles.subtitle}>Your payment process was cancelled.</p>
        </IonText>

        <IonCard className={styles.card}>
          <IonCardContent className={styles.cardContent}>
            <p>
              No charges have been made to your account.
            </p>
            <p>
              You can try again later or contact support if you need assistance.
            </p>
          </IonCardContent>
        </IonCard>

        {deviceId && (
          <IonButton
            expand="block"
            className={styles.button}
            routerLink={`/devices/${deviceId}`}
          >
            <IonIcon slot="start" icon={arrowBack} />
            Return to Device
          </IonButton>
        )}
      </div>
    </PaymentPageLayout>
  );
};

export default PaymentCancelPage;